'use strict';

define('vb/private/services/ramp/transformsUtils',[
  'vb/private/types/dataProviderConstants',
  'vb/private/utils',
], (DPConstants, Utils) => {
  /**
   * Built-in transforms paths used by Business Objects services.
   * See vbRequireConfig, both point to 'vb/private/services/ramp/rampTransforms'.
   */
  const SERVICE_RAMP_TRANSFORMS_PATH = 'vb/ServiceRampTransforms';
  const BUSINESS_OBJECTS_TRANSFORMS_PATH = 'vb/BusinessObjectsTransforms';

  /**
   * Default DataProvider capabilities used with Business Objects transforms.
   * Capabilities for 'vb/BusinessObjectsTransforms' are well known and do not need to be derived from
   * endpoint metadata.
   * See https://oracle-one.slack.com/archives/GRZ9B3A06/p1775848752385319?thread_ts=1771552930.654319&cid=GRZ9B3A06.
   */
  const DEFAULT_BUSINESS_OBJECTS_CAPABILITIES = Object.freeze({
    fetchByKeys: Object.freeze({
      implementation: DPConstants.CapabilityValues.FETCH_BY_KEYS_IMPLEMENTATION_LOOKUP,
      multiKeyLookup: DPConstants.CapabilityValues.FETCH_BY_KEYS_MULTI_KEY_LOOKUP_YES,
    }),
    fetchFirst: Object.freeze({
      implementation: DPConstants.CapabilityValues.FETCH_FIRST_IMPLEMENTATION_ITERATION,
      iterateAfterDone: DPConstants.CapabilityValues.FETCH_FIRST_ITERATE_AFTER_DONE_NOT_ALLOWED,
    }),
    fetchByOffset: Object.freeze({
      implementation: DPConstants.CapabilityValues.FETCH_BY_OFFSET_IMPLEMENTATION_RANDOM_ACCESS,
    }),
    sort: Object.freeze({
      attributes: DPConstants.CapabilityValues.SORT_ATTRIBUTES_MULTIPLE,
    }),
    filter: Object.freeze({
      operators: Object.freeze([...DPConstants.CapabilityValues.FILTER_OPERATORS_OPS]),
      textFilter: true,
    }),
  });

  class TransformsUtils {
    static get DEFAULT_BUSINESS_OBJECTS_CAPABILITIES() {
      return DEFAULT_BUSINESS_OBJECTS_CAPABILITIES;
    }

    static getBusinessObjectsCapabilities() {
      return Utils.cloneObject(DEFAULT_BUSINESS_OBJECTS_CAPABILITIES);
    }

    static isBusinessObjectsTransformsPath(transformsPath) {
      return transformsPath === BUSINESS_OBJECTS_TRANSFORMS_PATH || transformsPath === SERVICE_RAMP_TRANSFORMS_PATH;
    }
  }

  return TransformsUtils;
});

